import { TOGGLE_STATUSS } from './actionTypes'

export const getToggleStatuss = (toggleStatuss) => {
	return {
		type: TOGGLE_STATUSS,
		payload: toggleStatuss,
	}
}
